import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ShareFormComponent } from './components/share-form/share-form.component';
import { PrimeModule } from '../prime.module';
import { ShareTableComponent } from './components/share-table/share-table.component';

@NgModule({
    declarations: [
    ShareFormComponent,
    ShareTableComponent
  ],
    imports: [
        CommonModule,
        PrimeModule
    ],
    exports: [
        ShareFormComponent,
        ShareTableComponent
    ],
    providers: []
})

export class ShareModule {}